import axios from 'axios';

const userService = axios.create({
  baseURL: process.env.REACT_APP_AUTH_URL,
  headers: { 'Content-Type': 'application/json' },
});

export default userService;
